export default "__VITE_ASSET__DLFc6h9F__"